import React from 'react';
import { IconButton, Tooltip } from '@mui/material';
import { useAssistantOptional } from './AssistantContext';

export default function AssistantButton() {
  const assistant = useAssistantOptional();
  if (!assistant?.status?.enabled) return null;
  const isOpen = Boolean(assistant.isOpen);

  return (
    <Tooltip title={isOpen ? 'Close assistant' : 'Assistant'}>
      <IconButton
        size="small"
        data-testid="chrome-assistant"
        aria-label={isOpen ? 'Close Signal Bridge assistant' : 'Open Signal Bridge assistant'}
        aria-pressed={isOpen}
        onClick={() => {
          if (assistant.toggleAssistant) assistant.toggleAssistant();
          else if (isOpen) assistant.closeAssistant();
          else assistant.openAssistant({});
        }}
        sx={{
          width: 28,
          height: 28,
          minWidth: 28,
          backgroundColor: isOpen ? '#0f172a' : '#1e293b',
          color: '#fff',
          fontSize: '0.62rem',
          fontWeight: 700,
          letterSpacing: '-0.02em',
          '&:hover': { backgroundColor: '#0f172a' },
        }}
      >
        AI
      </IconButton>
    </Tooltip>
  );
}
